module.exports = __webpack_public_path__ + "arrow_lenguage@2x.png?f078c39dd86142b9ace41ed3cf483d44";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_lenguage@2x.png
// module id = 161
// module chunks = 0